import React from 'react';
import Image from 'common/image/Image';

const TrustSealValueProps = () => {
    return (
        <div className="TrustSealValueProps">
            <div className="digicert-seal-container">
                <Image
                    className="digicert-seal-image"
                    cloudinaryImageId="logos/digicert-secured-seal"
                    width={100}
                    height={56}
                    alt="Norton DigiCert Seal"
                />
            </div>
            <div className="footer-value-props">
                <ul>
                    <li>4.9/5 App Store Rating (iOS)</li>
                    <li>A+ Better Business Bureau Rating</li>
                    <li>20+ Million Cars Parked</li>
                </ul>
            </div>
        </div>
    );
};

export default TrustSealValueProps;
